import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { Package, PackageHost } from '../../Container';
import { importDataViaLanguageModel } from './LanguageModelImportCommands';

export class LanguageModelImportPackage implements Package {

    public install = (host: PackageHost) => host
        .plug(inCommands(importDataViaLanguageModel));
}
